// src/animations/MotionWrappers.jsx

import React from "react";
import { motion } from "framer-motion";
import { containerVariants, itemVariants } from "./variants";

/**
 * A container that applies staggered animations to its children
 * and triggers them on scroll into view.
 *
 * Props:
 * - delayChildren: number of seconds to wait before animating first child
 * - staggerChildren: number of seconds between each child's animation
 */
export function MotionContainer({
  children,
  className,
  delayChildren,
  staggerChildren,
  ...props
}) {
  // Inject itemVariants into each direct child
  const wrapped = React.Children.map(children, (child) =>
    React.cloneElement(child, { variants: itemVariants })
  );

  return (
    <motion.div
      className={className}
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      // pass custom timing into variants
      custom={{ delayChildren, staggerChildren }}
      {...props}
    >
      {wrapped}
    </motion.div>
  );
}

/**
 * A simple wrapper for single items using the shared itemVariants.
 */
export function MotionItem({ children, className, ...props }) {
  return (
    <motion.div className={className} variants={itemVariants} {...props}>
      {children}
    </motion.div>
  );
}
